import type { ClientOrganizationData } from '@DigitaleDoerfer/digitale-doerfer-api';

import { isEmptyOrNull } from '@/shared/utils/string';

type Fragment = { mayorGreeting: string };

export const toCreatePayload = (
  fragment: Fragment
): ClientOrganizationData['territorialAuthority'] | undefined => {
  const mayorGreeting = fragment.mayorGreeting.trim();
  if (isEmptyOrNull(mayorGreeting)) {
    return undefined;
  }
  return { mayorGreeting };
};

export const toEditPayload = (
  fragment: Fragment
): NonNullable<ClientOrganizationData['territorialAuthority']> => ({
  mayorGreeting: fragment.mayorGreeting.trim()
});
